import { render, staticRenderFns } from "./DashboardActiveMatters.vue?vue&type=template&id=7f8a29b0&scoped=true"
import script from "./DashboardActiveMatters.vue?vue&type=script&lang=js"
export * from "./DashboardActiveMatters.vue?vue&type=script&lang=js"
import style0 from "./DashboardActiveMatters.vue?vue&type=style&index=0&id=7f8a29b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a29b0",
  null
  
)

export default component.exports